import { client } from "./index";
import { saveDownload } from "./orders";

// Data migration (Super Admin: any store; store owner: their own stores)
// data: { sourceUrl, destinationUrl, mode: "keep" | "replace" }
export const startMigration = (data) => client.post("/admin/migrations", data);
export const rerunMigration = (id) => client.post(`/admin/migrations/${id}/rerun`);
export const revertMigration = (id) => client.post(`/admin/migrations/${id}/revert`);
// Every migration, newest first: { migrations, pagination }. filters: { from, to, source, destination }
export const getMigrations = (page = 1, filters = {}) =>
  client.get("/admin/migrations", { params: { page, ...Object.fromEntries(Object.entries(filters).filter(([, v]) => v)) } });

// The store's data from before a migration (kept 2 days), as the Excel file the website editor can import
export async function downloadMigrationBackup(migration) {
  const response = await client.get(`/admin/migrations/${migration._id}/backup`, { params: { format: "xlsx" }, responseType: "blob" });
  saveDownload(response.data, `${migration.storeSlug}-before-migration.xlsx`, "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet");
}
export const getMigration = (id) => client.get(`/admin/migrations/${id}`);
